import { ToothPathology } from '../../../../graphql/graphql';
import parseSimplePathologyValue from './parseSimplePathologyValue';

export default function getHistoryValuePathology(value: ToothPathology) {
	const translatedValues = Object.entries(value)
		.filter(([, value]) => Boolean(value))
		.map(([key, value]) => parseSimplePathologyValue(key, value));

	return translatedValues.join(', ');
}
